import React from 'react'
import ResizeHandle from './helpers/ResizeHandle.jsx'

/**
 * Desktop layout — owns the <main className="ticketsPage"> wrapper and
 * the flex `.ticketsLayout` row that holds Inbox + Conversation + Context
 * with draggable ResizeHandles between them.
 *
 * State stays in the orchestrator: containerRef + layoutHeight come in
 * as props, resize callbacks are forwarded. The three view nodes are
 * passed in as already-rendered elements so the orchestrator owns prop
 * wiring and this layout only owns spatial structure.
 *
 * The mobile/tablet layouts (Phase 3/4) will compose the same three
 * view nodes inside different wrappers.
 */
function DesktopTicketsLayout({
  containerRef, isMobile, layoutHeight,
  selectedTicket, ticketDetails,
  inbox, conversation, context,
  onLeftResize, onRightResize
}) {
  return (
    <main className="ticketsPage" style={{ marginTop: 18 }}>
      <div
        ref={containerRef}
        className="ticketsLayout"
        style={{
          display: isMobile ? 'block' : 'flex',
          height: layoutHeight && !isMobile ? layoutHeight : undefined
        }}
      >
        {inbox}

        {/* Resize Handle - Left */}
        {selectedTicket && !isMobile && (
          <ResizeHandle onResize={onLeftResize} direction="horizontal" />
        )}

        {conversation}

        {/* Resize Handle - Right */}
        {selectedTicket && ticketDetails && !isMobile && (
          <ResizeHandle onResize={onRightResize} direction="horizontal" />
        )}

        {context}
      </div>
    </main>
  )
}

export default DesktopTicketsLayout
